<div class="fondo-gris" *ngIf="showModalArcade"> </div>

<app-search *ngIf="showModalArcade" (modalCloseDatos)="closeModalArcade($event)">
</app-search>

<form class="" [formGroup]="_gestionTercerosService.customerForm">

    <div class="row" formGroupName="datosIdentificacion">

        <div class="col-12 m-0 p-2">
            <!-- Fila con radio butons y checkbox -->

            <div class="row  justify-content-center"
                *ngIf="!_gestionTercerosService.sePuedeDesactivar && _gestionTercerosService.revocaDate">
                <div class="text-bold color_red">
                    <p class="m-0">{{'gestion_terceros.identificationData.revocaDateText' | translate}}
                        <span>{{_gestionTercerosService.revocaDate}}</span>
                    </p>
                </div>
            </div>

            <div class="formInit_identificacion">
                <div class="row">

                    <div class="col-1 ml-2 datos_identificacion mr-2 margin-top-08">
                        <span class="text-bold"> {{ "gestion_terceros.identificationData.source" | translate}}:</span>
                    </div>

                    <div class="col-4 margin-top-05">

                        <div class="form-group_terceros datos_identificacion row" [ngClass]="{'only_reading':formMode || !modoEdicion || _gestionTercerosService.newCustomer,
                        'opacitysoft':voClientes || _gestionTercerosService.newCustomer}">

                            <span class="mt-1 mr-1" appCurrentColor>
                                {{ "labels.taller" | translate}}:
                            </span>

                            <span appCurrentColor>
                                <input type="radio" id="test1" name="InternalAditionalRole"
                                    formControlName="InternalAditionalRole" value="0" />
                                <label for="test1" appCurrentColor> </label>
                            </span>

                            <span class="mt-1 mr-1" appCurrentColor>
                                {{ "gestion_terceros.identificationData.typeVehicleVO" | translate}}:
                            </span>

                            <span appCurrentColor>
                                <input type="radio" id="test2" name="InternalAditionalRole"
                                    formControlName="InternalAditionalRole" value="2" />
                                <label for="test2" appCurrentColor></label>
                            </span>

                            <span class="mt-1 mr-1" appCurrentColor>
                                {{ "gestion_terceros.identificationData.c_first" | translate}}:
                            </span>
                            <span appCurrentColor>
                                <input type="radio" id="test3" name="InternalAditionalRole"
                                    formControlName="InternalAditionalRole" value="3" />
                                <label for="test3" appCurrentColor> </label>
                            </span>
                        </div>

                    </div>
                    <div class="col-3 margin-top-05 p-0" [ngClass]="{ 'opacitysoft only_reading': voClientes}">
                        <div class="form-group_terceros datos_identificacion" [ngClass]="{ 'popoverClassic_red': this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').invalid  }">
                            <label class="mt-1 pix_40  text-right">{{"labels.tipo" | translate }}:</label>
                            <kendo-dropdownlist popoverPlacement="bottom" [popoverOnHover]="true" [popover]="myPopover20"
                                [ngClass]="{ 'is-invalid': this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').invalid }"
                                formControlName="customerType" [data]="comboCustomerCategorias"
                                [valuePrimitive]="true" textField="text" valueField="value"
                                [popupSettings]="{ width: 200 }" class="form-control anchurax60 float-right"
                                (valueChange)="valueChangeCT($event)">
                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                    <span class="kendo_list_template">{{ dataItem.text }}</span>
                                </ng-template>
                            </kendo-dropdownlist>
                            <popover-content #myPopover20>
                                <div class="body-tooltip" *ngIf="this._gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').invalid">
                                    <span [innerHtml]="'errors.required.campoObligatorio' | translate | returnHtml: 'html'"></span>
                                </div>
                            </popover-content>
                        </div>
                    </div>

                    <div class="col-3 ml-2 margin-top-08">
                        <label class="cb check" *ngIf="_gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').value === 'B'
                                                        || _gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').value === 'S'">
                            <input [attr.disabled]="formMode || !modoEdicion? true: null" type="checkbox"
                                (click)="selectProveedorMarca($event)" [checked]="proveedorMarca">
                            <span class="cb-field"></span>
                            <span class="cb-text">
                                {{"gestion_terceros.identificationData.provCitroen" | translate }}
                            </span>
                        </label>
                    </div>
                </div>

                <div class="row" *ngIf="pais === 'pt'">
                    <div class="col-md-3 ml-4 mb-1">
                        <label class="cb check">
                            <input [attr.disabled]="formMode || !modoEdicion? true: null" type="checkbox"
                                (click)="selectRegimenIva($event)"
                                [checked]="_gestionTercerosService.customerForm.controls.datosIdentificacion.get('VATRegime').value === 'RC'">
                            <span class="cb-field"></span>
                            <span class="cb-text">
                                {{"labels.regimen_iva" | translate }}
                            </span>
                        </label>
                    </div>
                </div>

            </div>

            <div class="row mt-1 pr-2 pl-2">

                <div class="col-12">
                    <div class="form-group_terceros datos_identificacion"
                        [ngClass]="{ 'popoverClassic_red': getValueCustomerCategory()  }">
                        <label class="mt-1 pix_120 text-right">{{
                            "labels.clientCategory" | translate }} :</label>

                        <kendo-dropdownlist popoverPlacement="bottom" [popoverOnHover]="true" [popover]="myPopover21"
                            [ngClass]="{ 'is-invalid': getValueCustomerCategory() }" [data]="categories"
                            [textField]="'Description'" [valueField]="'CUSTOMERCATEGORY'"
                            formControlName="customerCategory" class="form-control anchurax75 float-right"
                            (valueChange)="valueChangeCC($event)"
                            [disabled]="_gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').value === 'S' ||
                                         _gestionTercerosService.customerForm.controls.datosIdentificacion.get('customerType').value === 'L'">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.Description }}</span>
                            </ng-template>
                        </kendo-dropdownlist>

                        <popover-content #myPopover21>
                            <div class="body-tooltip anchurax75" *ngIf="getValueCustomerCategory()">
                                <span
                                    [innerHtml]="'errors.required.campoObligatorio' | translate | returnHtml: 'html'"></span>
                            </div>
                        </popover-content>

                    </div>
                </div>

            </div>

            <div class="row  pr-2 pl-2">

                <div class="col-12">
                    <div class="form-group_terceros datos_identificacion">
                        <label class=" mt-1 pix_120 text-right">{{ "labels.direccion" |
                            translate
                            }} :</label>
                        <input maxlength="50" (blur)="blurElementDatosDatosIdentificacion('address')"
                            placeholder="{{placeholderaddress}}"
                            [ngClass]="{ 'form-error': getValueControl('address') }" formControlName="address"
                            type="text" class="form-control  anchurax75 float-right" />
                    </div>
                </div>

            </div>

            <div class="row pr-2 pl-2">

                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion pl-3">
                        <label class="mt-1 pix_105 text-right">{{ "labels.codPostal" | translate }} :</label>
                        <input maxlength="8" formControlName="postalCode" type="text"
                               (paste)="changesPostalData($event.target.value)" (change)="changesPostalData($event.target.value)"
                               (keyup)="changesPostalData($event.target.value)"
                               class="form-control  anchurax50 float-right" pattern="^[0-9-]*$"
                               [ngClass]="{'form-error': _gestionTercerosService.customerForm.controls.datosIdentificacion.get('postalCode').invalid}"/>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion">
                        <label class=" mt-1  pix_105 text-right">{{ "labels.province" | translate }} :</label>
                        <input maxlength="50" formControlName="province" type="text"
                            class="form-control  anchurax50 float-right" />
                    </div>
                </div>

            </div>

            <div class="row pr-2 pl-2">

                <div class="col-6" *ngIf="!containResultsList">
                    <div class="form-group_terceros datos_identificacion pl-3">
                        <label class="pix_105 mt-1 text-right">{{ "labels.ciudad" | translate }} :</label>
                        <input maxlength="50" formControlName="city" type="text"
                            class="form-control anchurax50 float-right" />
                    </div>
                </div>

                <div class="col-6" *ngIf="containResultsList">
                    <div class="form-group_terceros datos_identificacion pl-3">
                        <label class="pix_105 mt-1 text-right">{{ "labels.ciudad" | translate }} :</label>
                        <kendo-dropdownlist formControlName="city" [data]="listDataCity" [textField]="'City'"
                            [valueField]="'City'" [valuePrimitive]="true" class="form-control anchurax50 float-right altura1_5">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.City }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion">
                        <label class="pix_105 mt-1 text-right">{{ "labels.pais" | translate }} :</label>
                        <kendo-dropdownlist formControlName="pais" [data]="newPaises" [textField]="'Name'"
                            [valueField]="'CountryCode'" (valueChange)="valueChangePais($event)"
                            [defaultItem]="PaisCodeCustomer" class="form-control anchurax50 float-right altura1_5">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.Name }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                    </div>

                </div>

            </div>
            <div class="row pr-2 pl-2">
                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion pl-3">
                        <label class="pix_105 mt-1 text-right">{{ "labels.nacionalidad" | translate }} :</label>
                        <kendo-dropdownlist formControlName="NationalityCode"
                                            [valuePrimitive]="true"
                                            [data]="newPaises"
                                            [textField]="'Name'"
                                            [valueField]="'CountryCode'"
                                            class="form-control anchurax50 float-right altura1_5">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.Name }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion">
                        <label class="pix_105 mt-1 text-right">{{ "labels.intracomunitario" | translate }} :</label>
                            <label class="cb check intra-check">
                                <input [attr.disabled]="formMode || !modoEdicion? true: null" type="checkbox"
                                    (click)="checkboxIntraCommunity($event)"
                                    [checked]="_gestionTercerosService.customerForm.controls.datosIdentificacion.get('IntraCommunity').value === true">
                                <span class="cb-field"></span>
                            </label>
                    </div>
                </div>
            </div>
            <div class="row pr-2 pl-2">

                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion pl-3">
                        <label class=" pix_105 text-right mt-1">{{
                            "gestion_terceros.identificationData.FLDBornDate" | translate }} :</label>
                        <div class="anchurax50 gestion_terceros float-right mb-1">
                            <calendario [formulario]="_gestionTercerosService.customerForm"
                                [controlGroup]="'datosIdentificacion'" [controlName]="'fechaNacimiento'"
                                [yearMin]="'01/01/1900'">
                            </calendario>
                        </div>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion" *ngIf="proveedorMarca">
                        <label class="pix_105 text-right mt-2">
                            {{ "gestion_terceros.identificationData.arcadCode" | translate }} :</label>
                        <button (click)="openModalArcade()"
                            class="btn btn-secondary float-right  btn-sm altura1_5 mt-1">
                            <i class="iconSearch k-icon k-i-search"></i>
                        </button>
                        <input (blur)="blurElementDatosDatosIdentificacion('arcadCode')"
                            placeholder="{{placeholderarcadCode}}"
                            [ngClass]="{ 'form-error': getValueControl('arcadCode') }" formControlName="arcadCode"
                            type="text" class="mt-1 form-control anchurax35 mr-1 float-right" />
                    </div>
                </div>

            </div>

            <div class="row pr-2 pl-2">
                <div class="col-12">
                    <div class="form-group_terceros datos_identificacion">
                        <label class="mt-2  pix_120 text-right">
                            {{ "labels.notas" | translate}} :</label>
                        <textarea maxLength="200" formControlName="notas"
                            class="anchurax75 form-control-sm float-right form-control noResize " kendoTextArea>
            </textarea>
                    </div>
                </div>
            </div>

            <div class="row  pr-2 pl-2 mt-1">
                <div class="col-6">
                    <div class="form-group_terceros datos_identificacion pl-3 only_reading">
                        <label class="mt-1  pix_120 text-right">
                            {{ 'gestion_terceros.identificationData.id_first' | translate }} :</label>
                        <input formControlName="sfCustomerId" type="text" class="form-control anchurax50 float-right" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</form>
